/*[03/28/22,PC_DF_05,WW-371], Priyanka D */
import React, { Component } from 'react';
import * as ItemDetailNewAction from '../actions/ItemDetailNewAction';
import * as SearchResultsAction from '../actions/SearchResultsAction';
import * as DoorFormAction from '../actions/DoorFormAction';
import ItemDetailNewStore from '../stores/ItemDetailNewStore';
import DoorFormStore from '../stores/DoorFormStore';
import SearchResultsStore from '../stores/SearchResultsStore';
import * as NonCatalogAction from '../actions/NonCatalogAction';
import NonCatalogStore from '../stores/NonCatalogStore';
import * as $ from 'jquery';
import * as CookieService from '../CookieService';
import SDIConstants from '../SDIConstants';
import Select from 'react-select';
import { withTranslation, Trans } from 'react-i18next'
import { pdf } from '@react-pdf/renderer';
import { saveAs } from 'file-saver';
import { MapInteractionCSS } from 'react-map-interaction';
import DoorPDFComponent from './DoorFormPDFComponent'
import * as QuickItemAction from '../actions/QuickItemAction';
import QuickItemStore from '../stores/QuickItemStore';
import swal from 'sweetalert';
class DoorFormComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            WillYouNeedArray: [],
            SelectedWillUNeed: [],
            NoWillUneedstyle: "308px",
            WillUNeedStyle: "244px"
        }
    }
    componentDidMount() {
        this.GetSwingData()
        DoorFormStore.on('SwingFormDetail', this.SwingFormDetail);
        /*[03/28/22,PC_DF_14,WW-371], Priyanka D */
        NonCatalogStore.on('FormsattachmentResponse', this.loadAttachments);
        SearchResultsStore.on("Status", this.AddtocartSuccess);
        ItemDetailNewStore.on("addToCart", this.AddToCartResponse);
        QuickItemStore.on("submitQuickItem", this.submitQuickItemResponse);
    }
    componentWillUnmount() {
        DoorFormStore.removeListener('SwingFormDetail', this.SwingFormDetail);
        NonCatalogStore.removeListener('FormsattachmentResponse', this.loadAttachments);
        SearchResultsStore.removeListener("Status", this.AddtocartSuccess);
        ItemDetailNewStore.removeListener("addToCart", this.AddToCartResponse);
        QuickItemStore.removeListener("submitQuickItem", this.submitQuickItemResponse);
    }

    GetSwingData = () => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        DoorFormAction.GetSwingData()
    }
    Proceedremoveup = () => {
        /*[04/06/22,Bug ID:2017]Restricting the user to add the same Door item  to Shopping cart when Item is already available in the cart. Priyanka D */
        let ItemID = "";
        if (this.props.location.state.pagename == "SearchResult") {
            ItemID = this.props.location.state.item.NonItemDetails[0].ItemId
        }
        else {
            ItemID = this.props.location.state.item.NonItemDetails[0].ItemId
        }
        if (this.state.DoorSwingType == undefined || this.state.DoorSwingType == null || this.state.DoorSwingType == "" || this.state.DoorSwingType == " ") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please select Swing Type!"
            });
            // alert("Please select Swing Type!");
            return
        } else if ((CookieService.getLocalStorageValues("Doorlist") != undefined)) {
            if ((CookieService.getLocalStorageValues("Doorlist").indexOf(ItemID) > -1)) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "This Door Item is already added in the cart. Please go to cart to increase quantity !"
                });
                //  alert("This Door Item is already added in the cart. Please go to cart to increase quantity !")
                return
            } else {
                $('#ItemDetail').modal('show');
            }
        } else {
            $('#ItemDetail').modal('show');
        }
    }
    SwingFormDetail = () => {
        //debugger
        let SwingRefdata = JSON.parse(DoorFormStore.SwingFormDetails);
        if (SwingRefdata == undefined || SwingRefdata == null || SwingRefdata == "" || SwingRefdata == " ") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Technical Issue. Please contact SDI Customer care"
            });
            //alert("Technical Issue. Please contact SDI Customer care")           
            this.props.history.push({
                //pathname: "/shoppingcart",
                pathname: `\searchresults`,
            });
        } else {
            this.setState({ SwingRefdata: SwingRefdata })
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }

    /*[03/28/22,PC_DF_07,WW-371], Priyanka D */
    handleDoorType = (index, e) => {
        //debugger
        $(`#Doortype${index}`).prop('check', 'checked');
        $(`swing${this.state.DoorswingSelected}`).prop('checked', false);
        this.setState({
            Doortype: index, WillYouNeedArray: [], SelectedWillUNeed: [], Hinge: "", DoorVeiwer: "", Shutter: "", LightKit: "", ExitDevice: "", ExitTrim: "", Leverset: "", DeadBolt: "", PushPlate: "",
            PullPlate: "", Closer: "", Kickplate: "", SFIC: "", WeatherSeal: "", Threshold: "", ElectricStrike: "", CardReader: "", DoorOperator: "", TimeDelayModule: ""
        });

        switch (index) {
            case "0":
                {
                    this.setState({ DoorTypeValue: "CASH OFFICE (MORTISE)" })
                    break;
                }
            case "1":
                {
                    this.setState({ DoorTypeValue: "OFFICE" })
                    break;
                }
            case "2":
                {
                    this.setState({ DoorTypeValue: "BREAK ROOM" })
                    break;

                }
            case "3":
                {
                    this.setState({ DoorTypeValue: "RESTROOM" })
                    break;
                }
            case "4":
                {
                    this.setState({ DoorTypeValue: "FAMILY RESTROOM" })
                    break;
                }
            case "5":
                {
                    this.setState({ DoorTypeValue: "PHARMACY (MORTISE)" })
                    break;
                }
            case "6":
                {
                    this.setState({ DoorTypeValue: "OGP" })
                    break;
                }
        }
    }
    /*[03/28/22,PC_DF_10,WW-371], Priyanka D */
    handleWillUNeed = (name, event) => {
        //debugger;
        let WillYouNeedArray = this.state.WillYouNeedArray;
        let SelectedWillUNeed = this.state.SelectedWillUNeed;
        let SwingRefdata = this.state.SwingRefdata.filter((x) => x.DOOR_LOCATION == this.state.DoorTypeValue)
        if (WillYouNeedArray.length == 0 && !WillYouNeedArray.includes('Door Size')) {
            SwingRefdata.map((val, index) => {
                let localArray = {
                    value: val.DOOR_SIZE,
                    label: "Door Size", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                }
                WillYouNeedArray.push(localArray)
            });
        }
        switch (name) {
            case "Hinge": {
                this.setState({ [name]: event.currentTarget.checked });
                if (event.currentTarget.checked == true && SwingRefdata[0].HINGE != null) {
                    SwingRefdata.map((val, index) => {
                        let localArray = {
                            value: val.HINGE,
                            label: "Hinge", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                        }
                        WillYouNeedArray.push(localArray)
                    });
                    SelectedWillUNeed.push('Hinge')
                } else if (event.currentTarget.checked == true && SwingRefdata[0].HINGE == null) {
                    SelectedWillUNeed.push('Hinge')
                }
                else if (event.currentTarget.checked == false && SwingRefdata[0].HINGE != null) {
                    SwingRefdata.map((val, index) => {
                        let localArray = {
                            value: val.HINGE,
                            label: "Hinge", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                        }
                        let ind = WillYouNeedArray.findIndex(x => x.value == localArray.value && x.label == localArray.label);
                        WillYouNeedArray.splice(ind, 1)
                    });

                    let ind = SelectedWillUNeed.findIndex(y => y == "Hinge");
                    SelectedWillUNeed.splice(ind, 1)
                } else {
                    let ind = SelectedWillUNeed.findIndex(y => "Hinge");
                    SelectedWillUNeed.splice(ind, 1)
                }
                break;
            }
            case "DoorVeiwer": {
                this.setState({ [name]: event.currentTarget.checked });
                if (event.currentTarget.checked == true && SwingRefdata[0].DOOR_VIEWER != null) {
                    SwingRefdata.map((val, index) => {
                        let localArray = {
                            value: val.DOOR_VIEWER,
                            label: "Door Viewer", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                        }
                        WillYouNeedArray.push(localArray)
                    });
                    SelectedWillUNeed.push('Door Viewer')
                } else if (event.currentTarget.checked == true && SwingRefdata[0].DOOR_VIEWER == null) {
                    SelectedWillUNeed.push('Door Viewer')
                }
                else if (event.currentTarget.checked == false && SwingRefdata[0].DOOR_VIEWER != null) {
                    SwingRefdata.map((val, index) => {
                        let localArray = {
                            value: val.DOOR_VIEWER,
                            label: "Door Viewer", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                        }
                        let ind = WillYouNeedArray.findIndex(x => x.value == localArray.value && x.label == localArray.label);
                        WillYouNeedArray.splice(ind, 1)
                    });
                    let ind = SelectedWillUNeed.findIndex(y => y == "Door Viewer");
                    SelectedWillUNeed.splice(ind, 1)
                } else {
                    let ind = SelectedWillUNeed.findIndex(y => y == "Door Viewer");
                    SelectedWillUNeed.splice(ind, 1)
                }
                break;
            }
            case "Shutter": {
                this.setState({ [name]: event.currentTarget.checked });
                if (event.currentTarget.checked == true) {
                    SelectedWillUNeed.push('Shutter');
                } else {
                    let ind = SelectedWillUNeed.findIndex(y => y == "Shutter");
                    SelectedWillUNeed.splice(ind, 1)
                }
                break;
            }
            case "LightKit": {
                this.setState({ [name]: event.currentTarget.checked });
                if (event.currentTarget.checked == true && SwingRefdata[0].LIGHTKIT != null) {
                    SwingRefdata.map((val, index) => {
                        let localArray = {
                            value: val.LIGHTKIT,
                            label: "Light Kit", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                        }
                        WillYouNeedArray.push(localArray)
                    });
                    SelectedWillUNeed.push('Light Kit')
                } else if (event.currentTarget.checked == true && SwingRefdata[0].LIGHTKIT == null) {
                    SelectedWillUNeed.push('Light Kit')
                }
                else if (event.currentTarget.checked == false && SwingRefdata[0].LIGHTKIT != null) {
                    SwingRefdata.map((val, index) => {
                        let localArray = {
                            value: val.LIGHTKIT,
                            label: "Light Kit", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                        }
                        let ind = WillYouNeedArray.findIndex(x => x.value == localArray.value && x.label == localArray.label);
                        WillYouNeedArray.splice(ind, 1)
                    });
                    let ind = SelectedWillUNeed.findIndex(y => y == "Light Kit");
                    SelectedWillUNeed.splice(ind, 1)
                } else {
                    let ind = SelectedWillUNeed.findIndex(y => y == "Light Kit");
                    SelectedWillUNeed.splice(ind, 1)
                }
                break;
            }
            case "ExitDevice": {
                this.setState({ [name]: event.currentTarget.checked });
                if (event.currentTarget.checked == true && SwingRefdata[0].EXIT_DEVICE != null) {
                    SwingRefdata.map((val, index) => {
                        let localArray = {
                            value: val.EXIT_DEVICE,
                            label: "Exit device", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                        }
                        WillYouNeedArray.push(localArray)
                    });
                    SelectedWillUNeed.push('Exit Device')
                }
                else if (event.currentTarget.checked == true && SwingRefdata[0].EXIT_DEVICE == null) {
                    SelectedWillUNeed.push('Exit Device')
                } else if (event.currentTarget.checked == false && SwingRefdata[0].EXIT_DEVICE != null) {
                    SwingRefdata.map((val, index) => {
                        let localArray = {
                            value: val.EXIT_DEVICE,
                            label: "Exit Device", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                        }
                        let ind = WillYouNeedArray.findIndex(x => x.value == localArray.value && x.label == localArray.label);
                        WillYouNeedArray.splice(ind, 1)
                    });
                    let ind = SelectedWillUNeed.findIndex(y => y == "Exit device");
                    SelectedWillUNeed.splice(ind, 1)
                } else {
                    let ind = SelectedWillUNeed.findIndex(y => y == "Exit device");
                    SelectedWillUNeed.splice(ind, 1)
                }
                break;
            }
            case "ExitTrim": {
                this.setState({ [name]: event.currentTarget.checked });
                if (event.currentTarget.checked == true && SwingRefdata[0].EXIT_TRIM != null) {
                    SwingRefdata.map((val, index) => {
                        let localArray = {
                            value: val.EXIT_TRIM,
                            label: "Exit Trim", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                        }
                        WillYouNeedArray.push(localArray)
                    });

                    SelectedWillUNeed.push('Exit Trim')
                } else if (event.currentTarget.checked == true && SwingRefdata[0].EXIT_TRIM == null) {
                    SelectedWillUNeed.push('Exit Trim')
                }
                else if (SwingRefdata[0].EXIT_TRIM != null) {
                    SwingRefdata.map((val, index) => {
                        let localArray = {
                            value: val.EXIT_TRIM,
                            label: "Exit Trim", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                        }
                        let ind = WillYouNeedArray.findIndex(x => x.value == localArray.value && x.label == localArray.label);
                        WillYouNeedArray.splice(ind, 1)
                    });
                    let ind = SelectedWillUNeed.findIndex(y => y == "Exit Trim");
                    SelectedWillUNeed.splice(ind, 1)
                } else {
                    let ind = SelectedWillUNeed.findIndex(y => y == "Exit Trim");
                    SelectedWillUNeed.splice(ind, 1)
                }
                break;
            }
            case "DeadBolt": {
                this.setState({ [name]: event.currentTarget.checked });
                if (event.currentTarget.checked == true && SwingRefdata[0].DEADBOLT != null) {
                    SwingRefdata.map((val, index) => {
                        let localArray = {
                            value: val.DEADBOLT,
                            label: "Dead Bolt", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                        }
                        WillYouNeedArray.push(localArray)
                    });
                    SelectedWillUNeed.push('Dead Bolt')
                } else if (event.currentTarget.checked == true && SwingRefdata[0].DEADBOLT == null) {
                    SelectedWillUNeed.push('Dead Bolt')
                } else if (event.currentTarget.checked == false && SwingRefdata[0].DEADBOLT != null) {
                    SwingRefdata.map((val, index) => {
                        let localArray = {
                            value: val.DEADBOLT,
                            label: "Dead Bolt", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                        }
                        let ind = WillYouNeedArray.findIndex(x => x.value == localArray.value && x.label == localArray.label);
                        WillYouNeedArray.splice(ind, 1)
                    });
                    let ind = SelectedWillUNeed.findIndex(y => y == "Dead Bolt");
                    SelectedWillUNeed.splice(ind, 1)
                } else {
                    let ind = SelectedWillUNeed.findIndex(y => y == "Dead Bolt");
                    SelectedWillUNeed.splice(ind, 1)
                }
                break;
            }
            case "PushPlate": {
                this.setState({ [name]: event.currentTarget.checked });
                if (event.currentTarget.checked == true) {
                    //WW-401-UI issue in Door Form
                    SwingRefdata.map((val, index) => {
                        if (val.EXIT_DEVICE == "PUSH PLATE") {
                            let localArray = {
                                value: "Push Plate",
                                label: "Exit device",
                            }
                            WillYouNeedArray.push(localArray)
                        }
                    })
                    SelectedWillUNeed.push('Push Plate');
                } else {
                    SwingRefdata.map((val, index) => {
                        let localArray = {
                            value: "Push Plate",
                            label: "Exit device", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                        }
                        let ind = WillYouNeedArray.findIndex(x => x.value == localArray.value && x.label == localArray.label);
                        WillYouNeedArray.splice(ind, 1)
                    });
                    let ind = SelectedWillUNeed.findIndex(y => y == "Push Plate");
                    SelectedWillUNeed.splice(ind, 1)
                }
                break;
            }
            case "PullPlate": {
                this.setState({ [name]: event.currentTarget.checked });
                if (event.currentTarget.checked == true) {

                    SwingRefdata.map((val, index) => {
                        if (val.EXIT_TRIM == "PULL PLATE") {
                            let localArray = {
                                value: "Pull Plate",
                                label: "Exit Trim",// W-15_PC_02 to display the crib name (2/18/2022) -Aparna
                            }
                            WillYouNeedArray.push(localArray)
                        }
                    })
                    SelectedWillUNeed.push('Pull Plate');
                } else {
                    SwingRefdata.map((val, index) => {
                        let localArray = {
                            value: "Pull Plate",
                            label: "Exit Trim",// W-15_PC_02 to display the crib name (2/18/2022) -Aparna
                        }
                        let ind = WillYouNeedArray.findIndex(x => x.value == localArray.value && x.label == localArray.label);
                        WillYouNeedArray.splice(ind, 1)
                    });
                    let ind = SelectedWillUNeed.findIndex(y => y == "Pull Plate");
                    SelectedWillUNeed.splice(ind, 1)
                }
                break;
            }
            case "Closer": {
                this.setState({ [name]: event.currentTarget.checked });
                if (event.currentTarget.checked == true && SwingRefdata[0].CLOSER != null) {
                    SwingRefdata.map((val, index) => {
                        let localArray = {
                            value: val.CLOSER,
                            label: "Closer", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                        }
                        WillYouNeedArray.push(localArray)
                    });
                    SelectedWillUNeed.push('Closer')
                } else if (event.currentTarget.checked == true && SwingRefdata[0].CLOSER == null) {
                    SelectedWillUNeed.push('Closer')
                } else if (event.currentTarget.checked == false && SwingRefdata[0].CLOSER != null) {
                    SwingRefdata.map((val, index) => {
                        let localArray = {
                            value: val.CLOSER,
                            label: "Closer", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                        }
                        let ind = WillYouNeedArray.findIndex(x => x.value == localArray.value && x.label == localArray.label);
                        WillYouNeedArray.splice(ind, 1)
                    });
                    let ind = SelectedWillUNeed.findIndex(y => y == "Closer");
                    SelectedWillUNeed.splice(ind, 1)
                } else {
                    let ind = SelectedWillUNeed.findIndex(y => y == "Closer");
                    SelectedWillUNeed.splice(ind, 1)
                }
                break;
            }
            case "Kickplate": {
                this.setState({ [name]: event.currentTarget.checked });
                if (event.currentTarget.checked == true && SwingRefdata[0].KICKPLATE != null) {
                    SwingRefdata.map((val, index) => {
                        let localArray = {
                            value: val.KICKPLATE,
                            label: "Kick Plate", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                        }
                        WillYouNeedArray.push(localArray)
                    });
                    SelectedWillUNeed.push('Kick Plate') //WW-401-UI issue in Door Form
                } else if (event.currentTarget.checked == true && SwingRefdata[0].KICKPLATE == null) {
                    SelectedWillUNeed.push('Kick Plate') //WW-401-UI issue in Door Form
                } else if (event.currentTarget.checked == false && SwingRefdata[0].KICKPLATE != null) {
                    SwingRefdata.map((val, index) => {
                        let localArray = {
                            value: val.KICKPLATE,
                            label: "Kick Plate", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                        }
                        let ind = WillYouNeedArray.findIndex(x => x.value == localArray.value && x.label == localArray.label);
                        WillYouNeedArray.splice(ind, 1)
                    });
                    let ind = SelectedWillUNeed.findIndex(y => y == "Kick Plate");
                    SelectedWillUNeed.splice(ind, 1)
                } else {
                    let ind = SelectedWillUNeed.findIndex(y => y == "Kick Plate");
                    SelectedWillUNeed.splice(ind, 1)
                }
                break;
            }
            case "SFIC": {
                if (this.state.Doortype != "4" && this.state.Doortype != "6") {
                    this.setState({ [name]: event.currentTarget.checked });
                    if (event.currentTarget.checked == true && SwingRefdata[0].SFIC_LEVERSET != null) {
                        SwingRefdata.map((val, index) => {
                            let localArray = {
                                value: val.SFIC_LEVERSET,
                                label: "SFIC", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                            }
                            WillYouNeedArray.push(localArray)
                        });
                        SelectedWillUNeed.push('SFIC')
                    } else if (event.currentTarget.checked == true && SwingRefdata[0].SFIC_LEVERSET == null) {
                        SelectedWillUNeed.push('SFIC')
                    } else if (event.currentTarget.checked == false && SwingRefdata[0].SFIC_LEVERSET != null) {
                        SwingRefdata.map((val, index) => {
                            let localArray = {
                                value: val.SFIC_LEVERSET,
                                label: "SFIC", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                            }
                            let ind = WillYouNeedArray.findIndex(x => x.value == localArray.value && x.label == localArray.label);
                            WillYouNeedArray.splice(ind, 1)
                        });
                        let ind = SelectedWillUNeed.findIndex(y => y == "SFIC");
                        SelectedWillUNeed.splice(ind, 1)
                    } else {
                        let ind = SelectedWillUNeed.findIndex(y => y == "SFIC");
                        SelectedWillUNeed.splice(ind, 1)
                    }
                }
                /*[07/18/22, 2382-UI issue], Priyanka D */
                else if (this.state.Doortype == "6") {
                    this.setState({ [name]: event.currentTarget.checked });
                    if (event.currentTarget.checked == true && SwingRefdata[0].SFIC_HOUSING != null) {
                        SwingRefdata.map((val, index) => {
                            let localArray = {
                                value: val.SFIC_HOUSING,
                                label: "SFIC", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                            }
                            WillYouNeedArray.push(localArray)
                        });
                        SelectedWillUNeed.push('SFIC')
                    } else if (event.currentTarget.checked == true && SwingRefdata[0].SFIC_HOUSING == null) {
                        SelectedWillUNeed.push('SFIC')
                    } else if (event.currentTarget.checked == false && SwingRefdata[0].SFIC_HOUSING != null) {
                        SwingRefdata.map((val, index) => {
                            let localArray = {
                                value: val.SFIC_HOUSING,
                                label: "SFIC", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                            }
                            let ind = WillYouNeedArray.findIndex(x => x.value == localArray.value && x.label == localArray.label);
                            WillYouNeedArray.splice(ind, 1)
                        });
                        let ind = SelectedWillUNeed.findIndex(y => y == "SFIC");
                        SelectedWillUNeed.splice(ind, 1)
                    } else {
                        let ind = SelectedWillUNeed.findIndex(y => y == "SFIC");
                        SelectedWillUNeed.splice(ind, 1)
                    }
                } else {
                    this.setState({ [name]: event.currentTarget.checked });
                    if (event.currentTarget.checked == true && SwingRefdata[0].SFIC_DEADBOLT != null) {
                        SwingRefdata.map((val, index) => {
                            let localArray = {
                                value: val.SFIC_DEADBOLT,
                                label: "SFIC", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                            }
                            WillYouNeedArray.push(localArray)
                        });
                        SelectedWillUNeed.push('SFIC')
                    } else if (event.currentTarget.checked == true && SwingRefdata[0].SFIC_DEADBOLT == null) {
                        SelectedWillUNeed.push('SFIC')
                    } else if (event.currentTarget.checked == false && SwingRefdata[0].SFIC_DEADBOLT != null) {
                        SwingRefdata.map((val, index) => {
                            let localArray = {
                                value: val.SFIC_DEADBOLT,
                                label: "SFIC", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                            }
                            let ind = WillYouNeedArray.findIndex(x => x.value == localArray.value && x.label == localArray.label);
                            WillYouNeedArray.splice(ind, 1)
                        });
                        let ind = SelectedWillUNeed.findIndex(y => y == "SFIC");
                        SelectedWillUNeed.splice(ind, 1)
                    } else {
                        let ind = SelectedWillUNeed.findIndex(y => y == "SFIC");
                        SelectedWillUNeed.splice(ind, 1)
                    }
                }
                break;
            }
            case "WeatherSeal": {
                this.setState({ [name]: event.currentTarget.checked });
                if (event.currentTarget.checked == true && SwingRefdata[0].WEATHER_SEAL != null) {
                    SwingRefdata.map((val, index) => {
                        let localArray = {
                            value: val.WEATHER_SEAL,
                            label: "WeatherSeal", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                        }
                        WillYouNeedArray.push(localArray)
                    });
                    SelectedWillUNeed.push('WeatherSeal')
                } else if (event.currentTarget.checked == true && SwingRefdata[0].WEATHER_SEAL == null) {
                    SelectedWillUNeed.push('WeatherSeal')
                } else if (event.currentTarget.checked == false && SwingRefdata[0].WEATHER_SEAL != null) {
                    SwingRefdata.map((val, index) => {
                        let localArray = {
                            value: val.WEATHER_SEAL,
                            label: "WeatherSeal", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                        }
                        let ind = WillYouNeedArray.findIndex(x => x.value == localArray.value && x.label == localArray.label);
                        WillYouNeedArray.splice(ind, 1)
                    });
                    let ind = SelectedWillUNeed.findIndex(y => y == "WeatherSeal");
                    SelectedWillUNeed.splice(ind, 1)
                } else {
                    let ind = SelectedWillUNeed.findIndex(y => y == "WeatherSeal");
                    SelectedWillUNeed.splice(ind, 1)
                }
                break;
            }
            case "Threshold": {
                this.setState({ [name]: event.currentTarget.checked });
                if (event.currentTarget.checked == true && SwingRefdata[0].THRESHOLD != null) {
                    SwingRefdata.map((val, index) => {
                        let localArray = {
                            value: val.THRESHOLD,
                            label: "Threshold", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                        }
                        WillYouNeedArray.push(localArray)
                    });
                    SelectedWillUNeed.push('Threshold')
                } else if (event.currentTarget.checked == true && SwingRefdata[0].THRESHOLD == null) {
                    SelectedWillUNeed.push('Threshold')
                } else if (event.currentTarget.checked == false && SwingRefdata[0].THRESHOLD != null) {
                    SwingRefdata.map((val, index) => {
                        let localArray = {
                            value: val.THRESHOLD,
                            label: "Threshold", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                        }
                        let ind = WillYouNeedArray.findIndex(x => x.value == localArray.value && x.label == localArray.label);
                        WillYouNeedArray.splice(ind, 1)
                    });
                    let ind = SelectedWillUNeed.findIndex(y => y == "Threshold");
                    SelectedWillUNeed.splice(ind, 1)
                } else {
                    let ind = SelectedWillUNeed.findIndex(y => y == "Threshold");
                    SelectedWillUNeed.splice(ind, 1)
                }
                break;
            }
            case "ElectricStrike": {
                this.setState({ [name]: event.currentTarget.checked });
                if (event.currentTarget.checked == true && SwingRefdata[0].ELECTRIC_STRIKE != null) {
                    SwingRefdata.map((val, index) => {
                        let localArray = {
                            value: val.ELECTRIC_STRIKE,
                            label: "ElectricStrike", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                        }
                        WillYouNeedArray.push(localArray)
                    });
                    SelectedWillUNeed.push('ElectricStrike')
                } else if (event.currentTarget.checked == true && SwingRefdata[0].ELECTRIC_STRIKE == null) {
                    SelectedWillUNeed.push('ElectricStrike')
                } else if (event.currentTarget.checked == false && SwingRefdata[0].ELECTRIC_STRIKE != null) {
                    SwingRefdata.map((val, index) => {
                        let localArray = {
                            value: val.ELECTRIC_STRIKE,
                            label: "ElectricStrike", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                        }
                        let ind = WillYouNeedArray.findIndex(x => x.value == localArray.value && x.label == localArray.label);
                        WillYouNeedArray.splice(ind, 1)
                    });
                    let ind = SelectedWillUNeed.findIndex(y => y == "ElectricStrike");
                    SelectedWillUNeed.splice(ind, 1)
                } else {
                    let ind = SelectedWillUNeed.findIndex(y => y == "ElectricStrike");
                    SelectedWillUNeed.splice(ind, 1)
                }
                break;
            }
            case "CardReader": {
                this.setState({ [name]: event.currentTarget.checked });
                if (event.currentTarget.checked == true && SwingRefdata[0].CARD_READER != null) {
                    SwingRefdata.map((val, index) => {
                        let localArray = {
                            value: val.CARD_READER,
                            label: "Card Reader", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                        }
                        WillYouNeedArray.push(localArray)
                    });
                    SelectedWillUNeed.push('Card Reader')
                } else if (event.currentTarget.checked == true && SwingRefdata[0].CARD_READER == null) {
                    SelectedWillUNeed.push('Card Reader')
                } else if (event.currentTarget.checked == false && SwingRefdata[0].CARD_READER != null) {
                    SwingRefdata.map((val, index) => {
                        let localArray = {
                            value: val.CARD_READER,
                            label: "Card Reader", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                        }
                        let ind = WillYouNeedArray.findIndex(x => x.value == localArray.value && x.label == localArray.label);
                        WillYouNeedArray.splice(ind, 1)
                    });
                    let ind = SelectedWillUNeed.findIndex(y => y == "Card Reader");
                    SelectedWillUNeed.splice(ind, 1)
                } else {
                    let ind = SelectedWillUNeed.findIndex(y => y == "Card Reader");
                    SelectedWillUNeed.splice(ind, 1)
                }
                break;
            }
            case "DoorOperator": {
                this.setState({ [name]: event.currentTarget.checked });
                if (event.currentTarget.checked == true && SwingRefdata[0].DOOR_OPERATOR != null) {
                    SwingRefdata.map((val, index) => {
                        let localArray = {
                            value: val.DOOR_OPERATOR,
                            label: "Door Operator", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                        }
                        WillYouNeedArray.push(localArray)
                    });
                    SelectedWillUNeed.push('Door Operator')
                } else if (event.currentTarget.checked == true && SwingRefdata[0].DOOR_OPERATOR == null) {
                    SelectedWillUNeed.push('Door Operator')
                } else if (event.currentTarget.checked == false && SwingRefdata[0].DOOR_OPERATOR != null) {
                    SwingRefdata.map((val, index) => {
                        let localArray = {
                            value: val.DOOR_OPERATOR,
                            label: "Door Operator", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                        }
                        let ind = WillYouNeedArray.findIndex(x => x.value == localArray.value && x.label == localArray.label);
                        WillYouNeedArray.splice(ind, 1)
                    });
                    let ind = SelectedWillUNeed.findIndex(y => y == "Door Operator");
                    SelectedWillUNeed.splice(ind, 1)
                } else {
                    let ind = SelectedWillUNeed.findIndex(y => y == "Door Operator");
                    SelectedWillUNeed.splice(ind, 1)
                }
                break;
            }
            case "TimeDelayModule": {
                this.setState({ [name]: event.currentTarget.checked });
                if (event.currentTarget.checked == true && SwingRefdata[0].TIME_DELAY_MODULE != null) {
                    SwingRefdata.map((val, index) => {
                        let localArray = {
                            value: val.TIME_DELAY_MODULE,
                            label: "Time Delay Module", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                        }
                        WillYouNeedArray.push(localArray)
                    });
                    SelectedWillUNeed.push('Time Delay Module')
                } else if (event.currentTarget.checked == true && SwingRefdata[0].TIME_DELAY_MODULE == null) {
                    SelectedWillUNeed.push('Time Delay Module')
                } else if (event.currentTarget.checked == false && SwingRefdata[0].TIME_DELAY_MODULE != null) {
                    SwingRefdata.map((val, index) => {
                        let localArray = {
                            value: val.TIME_DELAY_MODULE,
                            label: "Time Delay Module", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                        }
                        let ind = WillYouNeedArray.findIndex(x => x.value == localArray.value && x.label == localArray.label);
                        WillYouNeedArray.splice(ind, 1)
                    });
                    let ind = SelectedWillUNeed.findIndex(y => y == "Time Delay Module");
                    SelectedWillUNeed.splice(ind, 1)
                } else {
                    let ind = SelectedWillUNeed.findIndex(y => y == "Time Delay Module");
                    SelectedWillUNeed.splice(ind, 1)
                }
                break;
            }
            case "Leverset": {
                this.setState({ [name]: event.currentTarget.checked });
                if (event.currentTarget.checked == true && SwingRefdata[0].LEVERSET != null) {
                    SwingRefdata.map((val, index) => {
                        let localArray = {
                            value: val.LEVERSET,
                            label: "Leverset", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                        }
                        WillYouNeedArray.push(localArray)
                    });
                    SelectedWillUNeed.push('Leverset')
                } else if (event.currentTarget.checked == true && SwingRefdata[0].LEVERSET == null) {
                    SelectedWillUNeed.push('Leverset')
                } else if (event.currentTarget.checked == false && SwingRefdata[0].LEVERSET != null) {
                    SwingRefdata.map((val, index) => {
                        let localArray = {
                            value: val.LEVERSET,
                            label: "Leverset", //WBW-15_PC_02 to display the crib name (2/18/2022) -Aparna
                        }
                        let ind = WillYouNeedArray.findIndex(x => x.value == localArray.value && x.label == localArray.label);
                        WillYouNeedArray.splice(ind, 1)
                    });
                    let ind = SelectedWillUNeed.findIndex(y => y == "Leverset");
                    SelectedWillUNeed.splice(ind, 1)
                } else {
                    let ind = SelectedWillUNeed.findIndex(y => y == "Leverset");
                    SelectedWillUNeed.splice(ind, 1)
                }
                break;
            }
        }
        console.log("WillYouNeedArray", WillYouNeedArray)
        this.setState({ WillYouNeedArray: WillYouNeedArray, SelectedWillUNeed: SelectedWillUNeed })
    }
    /*[03/28/22,PC_DF_08,WW-371], Priyanka D */
    handleDoorSwing = (index, event) => {
        let DoorSwingArray = [];
        $(`swing${index}`).prop('check', 'checked');
        switch (index) {
            case "0":
                {
                    this.setState({ DoorSwingType: "Right Hand" })
                    break;
                }
            case "1":
                {
                    this.setState({ DoorSwingType: "Right Hand reversed" })
                    break;
                }
            case "2":
                {
                    this.setState({ DoorSwingType: "Left hand" })
                    break;

                }
            case "3":
                {
                    this.setState({ DoorSwingType: "Left Hand reversed" })
                    break;
                }

        }
        console.log("DoorSwingType", this.state.DoorSwingType)
    }
    /*[03/28/22,PC_DF_15,WW-371], Priyanka D */
    handleAttachment = (b) => {
        var b = new File([b], 'Doorform.pdf');
        let files = [];
        files.push(b);
        if (files.length > 0) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Item Successfully Added To Cart"
            });
            //   alert("Item Successfully Added To Cart")
            NonCatalogAction.FormsaddAttachment(files);
        }
    }
    /*[03/28/22,PC_DF_14,WW-371], Priyanka D */
    loadAttachments = () => {
        //debugger
        let isValid = NonCatalogStore.attachmentResponse.indexOf("You have exceeded the length of total file names") >= 0 ? false : true;
        if (isValid) {
            let attachmentResponse = JSON.parse(NonCatalogStore.attachmentResponse);
            console.log("attachmentResponse", attachmentResponse);
            let tempAttachments = this.state.attachmentPathArr;
            tempAttachments = attachmentResponse;
            this.setState({ attachmentPathArr: tempAttachments });
            this.AddToCart();

        } else {
            this.setState({
                attachmentErrormsg: "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names."
            });
        }
    };
    /*[03/28/22,PC_DF_16,WW-371], Priyanka D */
    AddToCart() {
        //debugger
        console.log('pagename', this.props.location.state.pagename);
        let quantity = this.props.location.state.qty;
        if (this.props.location.state.pagename == 'ItemDetail') {
            if (this.props.location.state.item.NonItemDetails[0] != undefined) {
                this.props.location.state.item.NonItemDetails[0].filePath = this.state.attachmentPathArr[0].FilePath;
                //debugger
            }

            SearchResultsAction.AddCart(this.props.location.state.item)

        }
        else if (this.props.location.state.pagename == 'SearchResult') {
            if (this.props.location.state.item.NonItemDetails[0] != undefined) {
                this.props.location.state.item.NonItemDetails[0].filePath = this.state.attachmentPathArr[0].FilePath;
                //debugger
            }

            SearchResultsAction.AddCart(this.props.location.state.item)

        }
        else if (this.props.location.state.pagename == 'QuickItem') {
            if (this.props.location.state.CartBO != undefined) {
                this.props.location.state.CartBO.File_Path = "|"
                this.props.location.state.CartBO.File_Path += this.state.attachmentPathArr[0].FilePath;
                //debugger
            }
            QuickItemAction.submitQuickItem(this.props.location.state.CartBO)
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please complete the form"
            });
            //  alert("Please complete the form");
        }
    }
    cancelClick = () => {
        window.history.go(-1)
    }
    /*[03/28/22,PC_DF_18,WW-371], Priyanka D */
    AddToCartResponse = () => {
        let AddCartResponse = JSON.parse(ItemDetailNewStore.addToCartList);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        $('#ItemDetail').modal('hide');
        let SuccessFlag = AddCartResponse.SuccessFLag;
        let Update_Session = AddCartResponse._FlagDt;
        if (SuccessFlag[0].Status == "true" || SuccessFlag[0].Status == "True") {
            if (Update_Session[0].dtCM != [] && Update_Session[0].dtCM != "") {
                CookieService.updateLocalStorageValues("Session_dtCM", Update_Session[0].dtCM);
            }
            if (Update_Session[0].Session_gotStock != null && Update_Session[0].Session_gotStock != "") {
                CookieService.updateLocalStorageValues("Session_gotStock", Update_Session[0].Session_gotStock);
            }
            if (Update_Session[0].Session_gotNSTK != null && Update_Session[0].Session_gotNSTK != "") {
                CookieService.updateLocalStorageValues("Session_gotNSTK", Update_Session[0].Session_gotNSTK);
            }
            if (Update_Session[0].Session_CARTFAIL != null && Update_Session[0].Session_CARTFAIL != "") {
                CookieService.updateLocalStorageValues("Session_CARTFAIL", Update_Session[0].Session_CARTFAIL);
            }
            this.props.history.push({
                //pathname: "/shoppingcart",
                pathname: `\shoppingcart`
            });
        }
        else {
            if (Update_Session[0].Session_CARTFAIL != null && Update_Session[0].Session_CARTFAIL != "") {
                CookieService.updateLocalStorageValues("Session_CARTFAIL", Update_Session[0].Session_CARTFAIL);
            }
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Techincal Issue Contact SDI Customer Care"
            });
            // alert("Techincal Issue Contact SDI Customer Care");
        }
    }
    submitQuickItemResponse = () => {
        $('#ItemDetail').modal('hide');
        this.props.history.push({
            //pathname: "/shoppingcart",
            pathname: `\shoppingcart`
        });
    }
    /*[03/28/22,PC_DF_17,WW-371], Priyanka D */
    AddtocartSuccess = () => {
        //$(`#${SDIConstants.SDILoader}`).addClass('hide');
        //debugger
        let Status = JSON.parse(SearchResultsStore.SuccessStatus);
        $('#ItemDetail').modal('hide');
        let itemstatus = Status._FlagDt
        let iteminsertstatus = Status.SuccessFLag
        let PageLSearchResults = this.state.PageLoadSearchResults;
        let FilterdValue = this.state.FilteredSearchResults;
        if (itemstatus.length > 0) {
            if (itemstatus[0].is_Success == "True" || itemstatus[0].is_Success == "true") {

                let itemidnotinserted = ""
                if (iteminsertstatus != null && iteminsertstatus != undefined && iteminsertstatus != "") {
                    iteminsertstatus.map((val, index) => {
                        if (val.Status != "true") {
                            if (itemidnotinserted != "") {
                                itemidnotinserted = itemidnotinserted + "," + val.ItemId
                            }
                            else {
                                itemidnotinserted = itemidnotinserted + val.ItemId
                            }
                        }
                    });
                }
                if (itemidnotinserted != null && itemidnotinserted != undefined && itemidnotinserted != "") {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Item " + itemidnotinserted + " is not added to cart due to technical issue. Contact SDI customer care."
                    });
                    //  alert("Item " + itemidnotinserted + " is not added to cart due to technical issue. Contact SDI customer care.")
                }

                //window.location.reload();
                //$(`#${SDIConstants.SDILoader}`).removeClass('hide');

                this.props.history.push({
                    //pathname: "/shoppingcart",
                    pathname: `\shoppingcart`,
                    search: `?SearchKey=${this.props.location.state.searchKey}`
                });

            }
            else {

                let itemidnotinserted = ""
                let validate = false
                if (iteminsertstatus != null && iteminsertstatus != undefined && iteminsertstatus != "") {
                    iteminsertstatus.map((val, index) => {
                        if (val.Status != "true") {
                            if (itemidnotinserted != "") {
                                itemidnotinserted = itemidnotinserted + "," + val.ItemId
                            }
                            else {
                                itemidnotinserted = itemidnotinserted + val.ItemId
                            }
                        }
                        else if (validate != true && val.Status == "true") {
                            validate = true
                        }
                    });
                }
                if (itemidnotinserted != null && itemidnotinserted != undefined && itemidnotinserted != "") {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Item " + itemidnotinserted + " is not added to cart due to technical issue. Contact SDI customer care."
                    });
                    // alert("Item " + itemidnotinserted + " is not added to cart due to technical issue. Contact SDI customer care.")
                }
                if (validate == true) {

                    //window.location.reload();




                    this.props.history.push({
                        //pathname: "/shoppingcart",
                        pathname: `\shoppingcart`,
                        search: `?SearchKey=${this.props.location.state.searchKey}`
                    });


                }
                else if (itemidnotinserted == null || itemidnotinserted == undefined || itemidnotinserted == "") {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Techincal Issue Contact SDI Customer Care"
                    });
                    //  alert("Techincal Issue Contact SDI Customer Care")
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                }
                else {
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                }
            }
        }

    }

    /*[03/28/22,PC_DF_06,WW-371], Priyanka D */
    render() {
        console.log("doortype", this.state.Doortype)
        return (
            <div class="container-fluid content-margin cctop">
                <div class="row">
                    <div className="col-md-12 page-heading my-3">
                        <h5 id="heading" className="page-title">Door Form</h5>
                    </div>
                    <div class="col-md-12 float-left mb-3">
                        <label class="catalog-label w-100">Choose a Door</label>
                        <label class="custom-radiobtn"> Cash Office
            <input type="radio" name="searchoption" id="Doortype0" onChange={(e) => this.handleDoorType("0", e)} />
                            <span class="checkmark checkmark-org"></span>
                        </label>
                        <label class="custom-radiobtn">Office
          <input type="radio" name="searchoption" id="Doortype1" onChange={(e) => this.handleDoorType("1", e)} />
                            <span class="checkmark checkmark-org"></span>
                        </label>
                        < label class="custom-radiobtn"> Break Room
          <input type="radio" name="searchoption" id="Doortype2" onChange={(e) => this.handleDoorType("2", e)} />
                            <span class="checkmark checkmark-org"></span>
                        </label>
                        <label class="custom-radiobtn"> RestRoom
         <input type="radio" name="searchoption" id="Doortype3" onChange={(e) => this.handleDoorType("3", e)} />
                            <span class="checkmark checkmark-org"></span>
                        </label>
                        <label class="custom-radiobtn"> Family RestRoom
        <input type="radio" name="searchoption" id="Doortype4" onChange={(e) => this.handleDoorType("4", e)} />
                            <span class="checkmark checkmark-org"></span>
                        </label>
                        <label class="custom-radiobtn"> Pharmacy
        <input type="radio" name="searchoption" id="Doortype5" onChange={(e) => this.handleDoorType("5", e)} />
                            <span class="checkmark checkmark-org"></span>
                        </label>
                        <label class="custom-radiobtn"> OGP
        <input type="radio" name="searchoption" id="Doortype6" onChange={(e) => this.handleDoorType("6", e)} />
                            <span class="checkmark checkmark-org"></span>
                        </label>

                    </div>
                    {this.state.Doortype == "5" || this.state.Doortype == "0" ?
                        <div class="col-md-12 float-left mb-2">
                            <p class="indicate-alert ">This Door is Prefabricated for a Mortise Leverset</p>
                        </div> : null}
                    {this.state.Doortype != undefined ?

                        <div class="col-md-12 float-left mb-3 p-0">

                            <div class="col-md-12 float-left mb-3">
                                <label class="catalog-label">Door Swing
              <span class="info-container">
                                        <img class="info-searchpage" src="Images/info-icon.png" />
                                        <span class="info-content info-position tooltip-info" style={{ minWidth: "700px" }}> <img class="w-100 h-100" src="Images/door swing.png" /></span>
                                    </span>
                                </label>
                                <div class="w-100 float-left">
                                    <div class="custom-control col-md-2 custom-checkbox p-0 my-2 item-custom-control custcheck float-left">
                                        <label class="custom-radiobtn">Right Hand
                                          <input type="radio" name="searchoption1" id="swing0" onChange={(e) => this.handleDoorSwing("0", e)} />
                                            <span class="checkmark checkmark-org"></span>
                                        </label>

                                    </div>
                                    <div class="custom-control col-md-2 custom-checkbox p-0 my-2 item-custom-control custcheck float-left">
                                        <label class="custom-radiobtn">Right Hand Reverse
                                          <input type="radio" name="searchoption1" id="swing1" onChange={(e) => this.handleDoorSwing("1", e)} />
                                            <span class="checkmark checkmark-org"></span>
                                        </label>
                                    </div>
                                    <div class="custom-control col-md-2 custom-checkbox p-0 my-2 item-custom-control custcheck float-left">
                                        <label class="custom-radiobtn">Left Hand
                                          <input type="radio" name="searchoption1" id="swing2" onChange={(e) => this.handleDoorSwing("2", e)} />
                                            <span class="checkmark checkmark-org"></span>
                                        </label>
                                    </div>
                                    <div class="custom-control col-md-2 custom-checkbox p-0 my-2 item-custom-control custcheck float-left">
                                        <label class="custom-radiobtn">Left Hand Reverse
                                          <input type="radio" name="searchoption1" id="swing3" onChange={(e) => this.handleDoorSwing("3", e)} />
                                            <span class="checkmark checkmark-org"></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 float-left mb-3">
                                <label class="catalog-label">Will you need</label>
                                <div class="w-100 float-left">
                                    {this.state.Doortype == "0" || this.state.Doortype == "1" || this.state.Doortype == "2" || this.state.Doortype == "3" || this.state.Doortype == "4" || this.state.Doortype == "5" || this.state.Doortype == "6" ?
                                        <div class="custom-control col-md-2 custom-checkbox my-2 item-custom-control custcheck float-left">

                                            <input type="checkbox" class="custom-control-input" id="check1" checked={this.state.Hinge} onChange={(e) => this.handleWillUNeed("Hinge", e)} />
                                            <label class="custom-control-label priority-checkbox filter-checkbox" for="check1">Hinge</label>
                                        </div> : null}
                                    {this.state.Doortype == "0" ?
                                        <div class="custom-control col-md-2 custom-checkbox my-2 item-custom-control custcheck float-left">
                                            <input type="checkbox" class="custom-control-input" id="check2" checked={this.state.DoorVeiwer} onChange={(e) => this.handleWillUNeed("DoorVeiwer", e)} />
                                            <label class="custom-control-label priority-checkbox filter-checkbox" for="check2">Door Veiwer</label>
                                        </div> : null}
                                    {this.state.Doortype == "5" ?
                                        <div class="custom-control col-md-2 custom-checkbox my-2 item-custom-control custcheck float-left">
                                            <input type="checkbox" class="custom-control-input" id="check3" checked={this.state.Shutter} onChange={(e) => this.handleWillUNeed("Shutter", e)} />
                                            <label class="custom-control-label priority-checkbox filter-checkbox" for="check3">Shutter</label>
                                        </div> : null}
                                    {this.state.Doortype == "2" || this.state.Doortype == "1" || this.state.Doortype == "6" ?
                                        <div class="custom-control col-md-2 custom-checkbox my-2 item-custom-control custcheck float-left">
                                            <input type="checkbox" class="custom-control-input" id="check4" checked={this.state.LightKit} onChange={(e) => this.handleWillUNeed("LightKit", e)} />
                                            <label class="custom-control-label priority-checkbox filter-checkbox" for="check4">Light Kit</label>
                                        </div> : null}
                                    {this.state.Doortype == "6" ?
                                        <div class="custom-control col-md-2 custom-checkbox my-2 item-custom-control custcheck float-left">
                                            <input type="checkbox" class="custom-control-input" id="check5" checked={this.state.ExitDevice} onChange={(e) => this.handleWillUNeed("ExitDevice", e)} />
                                            <label class="custom-control-label priority-checkbox filter-checkbox" for="check5">Exit Device</label>
                                        </div> : null}
                                    {this.state.Doortype == "6" ?
                                        <div class="custom-control col-md-2 custom-checkbox my-2 item-custom-control custcheck float-left">
                                            <input type="checkbox" class="custom-control-input" id="check6" checked={this.state.ExitTrim} onChange={(e) => this.handleWillUNeed("ExitTrim", e)} />
                                            <label class="custom-control-label priority-checkbox filter-checkbox" for="check6">Exit Trim</label>
                                        </div> : null}
                                    {this.state.Doortype == "0" || this.state.Doortype == "2" || this.state.Doortype == "1" || this.state.Doortype == "5" || this.state.Doortype == "4" ?
                                        <div class="custom-control col-md-2 custom-checkbox my-2 item-custom-control custcheck float-left">
                                            <input type="checkbox" class="custom-control-input" id="check7" checked={this.state.Leverset} onChange={(e) => this.handleWillUNeed("Leverset", e)} />
                                            <label class="custom-control-label priority-checkbox filter-checkbox" for="check7">Leverset</label>
                                        </div> : null}
                                    {this.state.Doortype == "4" ?
                                        <div class="custom-control col-md-2 custom-checkbox my-2 item-custom-control custcheck float-left">
                                            <input type="checkbox" class="custom-control-input" id="check8" checked={this.state.DeadBolt} onChange={(e) => this.handleWillUNeed("DeadBolt", e)} />
                                            <label class="custom-control-label priority-checkbox filter-checkbox" for="check8">Dead Bolt</label>
                                        </div> : null}
                                    {this.state.Doortype == "3" ?
                                        <div class="custom-control col-md-2 custom-checkbox my-2 item-custom-control custcheck float-left">
                                            <input type="checkbox" class="custom-control-input" id="check9" checked={this.state.PushPlate} onChange={(e) => this.handleWillUNeed("PushPlate", e)} />
                                            <label class="custom-control-label priority-checkbox filter-checkbox" for="check9">Push Plate</label>
                                        </div> : null}
                                    {this.state.Doortype == "3" ?
                                        <div class="custom-control col-md-2 custom-checkbox my-2 item-custom-control custcheck float-left">
                                            <input type="checkbox" class="custom-control-input" id="check10" checked={this.state.PullPlate} onChange={(e) => this.handleWillUNeed("PullPlate", e)} />
                                            <label class="custom-control-label priority-checkbox filter-checkbox" for="check10">Pull Plate</label>
                                        </div> : null}
                                    {this.state.Doortype == "0" || this.state.Doortype == "2" || this.state.Doortype == "3" || this.state.Doortype == "4" || this.state.Doortype == "1" || this.state.Doortype == "5" ?
                                        <div class="custom-control col-md-2 custom-checkbox my-2 item-custom-control custcheck float-left">
                                            <input type="checkbox" class="custom-control-input" id="check11" checked={this.state.Closer} onChange={(e) => this.handleWillUNeed("Closer", e)} />
                                            <label class="custom-control-label priority-checkbox filter-checkbox" for="check11">Closer</label>
                                        </div> : null}
                                    {this.state.Doortype == "0" || this.state.Doortype == "4" || this.state.Doortype == "5" || this.state.Doortype == "3" || this.state.Doortype == "6" ?
                                        <div class="custom-control col-md-2 custom-checkbox my-2 item-custom-control custcheck float-left">
                                            <input type="checkbox" class="custom-control-input" id="check12" checked={this.state.Kickplate} onChange={(e) => this.handleWillUNeed("Kickplate", e)} />
                                            <label class="custom-control-label priority-checkbox filter-checkbox" for="check12">Kick Plate</label>
                                        </div> : null}
                                    {this.state.Doortype == "0" || this.state.Doortype == "2" || this.state.Doortype == "4" || this.state.Doortype == "1" || this.state.Doortype == "5" || this.state.Doortype == "6" ?
                                        <div class="custom-control col-md-2 custom-checkbox my-2 item-custom-control custcheck float-left">
                                            <input type="checkbox" class="custom-control-input" id="check13" checked={this.state.SFIC} onChange={(e) => this.handleWillUNeed("SFIC", e)} />
                                            <label class="custom-control-label priority-checkbox filter-checkbox" for="check13">SFIC</label>
                                            <span style={{ fontSize: "12px", float: "right", marginRight: "78px" }}>Check if store uses SFIC</span>
                                        </div> : null}
                                    {this.state.Doortype == "6" ?
                                        <div class="custom-control col-md-2 custom-checkbox my-2 item-custom-control custcheck float-left">
                                            <input type="checkbox" class="custom-control-input" id="check14" checked={this.state.WeatherSeal} onChange={(e) => this.handleWillUNeed("WeatherSeal", e)} />
                                            <label class="custom-control-label priority-checkbox filter-checkbox" for="check14">Weather Seal</label>
                                        </div> : null}
                                    {this.state.Doortype == "6" ?
                                        <div class="custom-control col-md-2 custom-checkbox my-2 item-custom-control custcheck float-left">
                                            <input type="checkbox" class="custom-control-input" id="check15" checked={this.state.Threshold} onChange={(e) => this.handleWillUNeed("Threshold", e)} />
                                            <label class="custom-control-label priority-checkbox filter-checkbox" for="check15">Threshold</label>
                                        </div> : null}
                                    {this.state.Doortype == "6" ?
                                        <div class="custom-control col-md-2 custom-checkbox my-2 item-custom-control custcheck float-left">
                                            <input type="checkbox" class="custom-control-input" id="check16" checked={this.state.ElectricStrike} onChange={(e) => this.handleWillUNeed("ElectricStrike", e)} />
                                            <label class="custom-control-label priority-checkbox filter-checkbox" for="check16">Electric Strike</label>
                                        </div> : null}
                                    {this.state.Doortype == "6" ?
                                        <div class="custom-control col-md-2 custom-checkbox my-2 item-custom-control custcheck float-left">
                                            <input type="checkbox" class="custom-control-input" id="check17" checked={this.state.CardReader} onChange={(e) => this.handleWillUNeed("CardReader", e)} />
                                            <label class="custom-control-label priority-checkbox filter-checkbox" for="check17">Card Reader</label>
                                        </div> : null}
                                    {this.state.Doortype == "6" ?
                                        <div class="custom-control col-md-2 custom-checkbox my-2 item-custom-control custcheck float-left">
                                            <input type="checkbox" class="custom-control-input" id="check18" checked={this.state.DoorOperator} onChange={(e) => this.handleWillUNeed("DoorOperator", e)} />
                                            <label class="custom-control-label priority-checkbox filter-checkbox" for="check18">Door Operator</label>
                                        </div> : null}
                                    {this.state.Doortype == "6" ?
                                        <div class="custom-control col-md-2 custom-checkbox my-2 item-custom-control custcheck float-left">
                                            <input type="checkbox" class="custom-control-input" id="check19" checked={this.state.TimeDelayModule} onChange={(e) => this.handleWillUNeed("TimeDelayModule", e)} />
                                            <label class="custom-control-label priority-checkbox filter-checkbox" for="check19">Time Delay Module</label>
                                        </div> : null}
                                    <div className="float-right mt-5">
                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn float-none non-catalog-mobile-btn px-5 mr-3" onClick={this.cancelClick}><Trans>Cancel</Trans></button>
                                        <button className="btn btn-primary custom-btn-primary primary-btn float-none non-catalog-mobile-btn px-5" onClick={() => this.Proceedremoveup()}><Trans>Add to Cart</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div> : null}
                    <div className="modal" id="ItemDetail" data-backdrop="static">
                        <div className="modal-dialog custom-removeup modal-dialog-centered" data-backdrop="static">

                            <div className="modal-content" style={{ "marginLeft": "78px" }}>
                                {/* Modal Header */}
                                <div className="modal-header bg-white border-0">
                                    <button type="button" className="btn close-btn bg-white" data-dismiss="modal" style={{ "marginLeft": "362px" }}>
                                        X
                                 </button>
                                </div>
                                {/* Modal body */}
                                <div className="text-center">
                                    <label>Door Type<span> : </span>{this.state.DoorTypeValue}</label>
                                </div>
                                <div className="text-center">
                                    <label>Door Swing<span> : </span>{this.state.DoorSwingType}</label>
                                </div>
                                {this.state.SelectedWillUNeed.length > 0 ?
                                    <div className="text-center">
                                        <label>You will get<span> :</span>
                                            {this.state.SelectedWillUNeed.map((val, index) => {
                                                return (<span><span>{index + 1 + "."}</span> <span>{val + "    "}</span></span>
                                                )
                                            })}
                                        </label>
                                    </div> : null}
                                <div className="col-md-12 mt-4 text-center mb-2">
                                    <button className="btn btn-primary custom-btn-primary primary-btn px-4 mr-2"
                                        onClick={
                                            async () => {

                                                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                                                const doc = <DoorPDFComponent
                                                    doortype={this.state.DoorTypeValue} DoorSwingType={this.state.DoorSwingType} WillYouNeedArray={this.state.WillYouNeedArray} SwingRefdata={this.state.SwingRefdata}
                                                />;
                                                const asPdf = pdf([]);
                                                asPdf.updateContainer(doc);
                                                const blob = await asPdf.toBlob();
                                                saveAs(blob, 'DoorForm.pdf');
                                                this.handleAttachment(blob);
                                            }
                                        }

                                    >Proceed</button>{/*[02/02/22, PC_EF_24, Priyanka.D]*/}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>)
    };

}
export default withTranslation()(DoorFormComponent);